import { cn } from 'lib/helpers/utility';

import Select from 'components/shared/Select/Select';
import Textarea from 'components/shared/Textarea/Textarea';
import RadioButton from 'components/shared/RadioButton/RadioButton';

import { PRACTICE_REGIONS } from '../lib/helpers';

const AdminSupportForm = ({ formik, providers, isAdmin }) => {
  return (
    <div className="flex w-full justify-center">
      <div className="w-full text-left">
        <div className="grid grid-cols-3 gap-3 px-0.5 md:grid-cols-2 sm:grid-cols-1">
          <Select
            inputId="consultantId"
            label="Management consultant"
            options={providers}
            name="consultantId"
            placeholder="Management consultant"
            onChange={(v) => formik.setFieldValue('consultantId', v?.value)}
            value={providers?.find((p) => p.value === formik.values.consultantId) || null}
            error={formik.errors.consultantId && formik.touched.consultantId}
            isMulti={false}
            required
          />
          <Select
            inputId="onboardingArchitectId"
            label="Onboarding architect"
            options={providers}
            name="onboardingArchitectId"
            placeholder="Onboarding architect"
            onChange={(v) => formik.setFieldValue('onboardingArchitectId', v?.value)}
            value={providers?.find((p) => p.value === formik.values.onboardingArchitectId) || null}
            error={formik.errors.onboardingArchitectId && formik.touched.onboardingArchitectId}
            isMulti={false}
          />
          <Select
            inputId="insideRepresentativeId"
            label="Inside representative"
            options={providers}
            name="insideRepresentativeId"
            placeholder="Inside representative"
            onChange={(v) => formik.setFieldValue('insideRepresentativeId', v?.value)}
            value={providers?.find((p) => p.value === formik.values.insideRepresentativeId) || null}
            error={formik.errors.insideRepresentativeId && formik.touched.insideRepresentativeId}
            isMulti={false}
          />
        </div>
        <div className="pt-3">
          <p
            className={cn(
              'text-sm font-medium',
              formik.errors.region && formik.touched.region && 'text-danger-500'
            )}>
            Please select where your practice is located
          </p>
          <div className="flex items-center gap-4 pt-2">
            <div
              onClick={() => {
                formik.setFieldValue('region', PRACTICE_REGIONS.EAST);
              }}>
              <RadioButton
                inputClassName=""
                isSelected={formik.values.region === PRACTICE_REGIONS.EAST}
                name="region"
                label="East Coast"
                wrapperClassName="radio--small"
              />
            </div>
            <div
              onClick={() => {
                formik.setFieldValue('region', PRACTICE_REGIONS.WEST);
              }}>
              <RadioButton
                disabled={!isAdmin}
                isSelected={formik.values.region === PRACTICE_REGIONS.WEST}
                name="region"
                label="West Coast"
                wrapperClassName="radio--small"
              />
            </div>
          </div>
        </div>
        <div className="pt-3">
          <p
            className={cn(
              'text-sm font-medium',
              formik.errors.medbillBuiltInBiller &&
                formik.touched.medbillBuiltInBiller &&
                'text-danger-500'
            )}>
            Is the practice using Medbill&#39;s Built-in-Biller?
          </p>
          <div className="flex items-center gap-4 pt-2">
            <div
              onClick={() => {
                formik.setFieldValue('medbillBuiltInBiller', true);
              }}>
              <RadioButton
                isSelected={formik.values.medbillBuiltInBiller}
                name="medbillBuiltInBiller"
                label="Yes"
                wrapperClassName="radio--small"
              />
            </div>
            <div
              onClick={() => {
                formik.setFieldValue('medbillBuiltInBiller', false);
              }}>
              <RadioButton
                isSelected={
                  formik.values.medbillBuiltInBiller !== null
                    ? !formik.values.medbillBuiltInBiller
                    : false
                }
                name="medbillBuiltInBiller"
                label="No"
                wrapperClassName="radio--small"
              />
            </div>
          </div>
        </div>
        <div className="pt-3">
          <p
            className={cn(
              'text-sm font-medium',
              formik.errors.medbillVirtualOfficeManager &&
                formik.touched.medbillVirtualOfficeManager &&
                'text-danger-500'
            )}>
            Does this practice use Medbill&#39;s Virtual Office Manager?
          </p>
          <div className="flex items-center gap-4 pt-2">
            <div
              onClick={() => {
                formik.setFieldValue('medbillVirtualOfficeManager', true);
              }}>
              <RadioButton
                isSelected={formik.values.medbillVirtualOfficeManager}
                name="medbillVirtualOfficeManager"
                label="Yes"
                wrapperClassName="radio--small"
              />
            </div>
            <div
              onClick={() => {
                formik.setFieldValue('medbillVirtualOfficeManager', false);
              }}>
              <RadioButton
                isSelected={
                  formik.values.medbillVirtualOfficeManager !== null
                    ? !formik.values.medbillVirtualOfficeManager
                    : false
                }
                name="medbillVirtualOfficeManager"
                label="No"
                wrapperClassName="radio--small"
              />
            </div>
          </div>
        </div>
        <div className="pt-3">
          <Textarea
            value={formik.values.generalNote}
            error={formik.errors.generalNote && formik.touched.generalNote}
            onChange={formik.handleChange}
            name="generalNote"
            id="generalNote"
            placeholder="Enter any extra details or comments for the Myriad team"
            textareaClassName="h-[82px]"
            disabled={!isAdmin}
            label="Additional notes"
          />
        </div>
      </div>
    </div>
  );
};

export default AdminSupportForm;
